import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuStateService implements OnDestroy {
  // Subject to broadcast menu close events to all components
  private closeAllMenusSource = new BehaviorSubject<boolean>(false);
  closeAllMenus$ = this.closeAllMenusSource.asObservable();
  
  // Track the currently active menu
  private activeMenuId: string | null = null;
  private boundHandleDocumentClick: any;

  constructor() {
    // Bind the method once and store the reference to properly remove it later
    this.boundHandleDocumentClick = this.handleDocumentClick.bind(this);
    
    // Add click event listener to document to close menus when clicking outside
    document.addEventListener('click', this.boundHandleDocumentClick);
  }

  ngOnDestroy(): void {
    // Clean up event listener
    document.removeEventListener('click', this.boundHandleDocumentClick);
    console.log('MenuStateService destroyed, removed document click listener');
  }

  // Handler for document clicks
  private handleDocumentClick(event: MouseEvent): void {
    if (this.activeMenuId) {
      console.log('Document click detected, closing all menus');
      this.closeAllMenus();
    }
  }

  // Method to close all menus
  closeAllMenus(): void {
    if (this.activeMenuId) {
      console.log('Closing all menus');
      this.closeAllMenusSource.next(true);
      this.activeMenuId = null;
      // Reset the subject after a short delay to allow components to process the event
      setTimeout(() => {
        this.closeAllMenusSource.next(false);
      }, 10);
    }
  }

  // Method to toggle a specific menu
  toggleMenu(menuId: string): boolean {
    // console.log('Toggle menu called for', menuId, 'current active menu:', this.activeMenuId);
    
    // If this menu is already active, close it
    if (this.activeMenuId === menuId) {
      console.log('Closing currently active menu');
      this.activeMenuId = null;
      return false;
    } else {
      // Close any open menu first
      if (this.activeMenuId) {
        console.log('Closing previous menu before opening new one');
        this.closeAllMenusSource.next(true);
        // Reset the subject after a short delay
        setTimeout(() => {
          this.closeAllMenusSource.next(false);
        }, 10);
      }
      
      // Then set this as the active menu
      // console.log('Setting new active menu:', menuId);
      this.activeMenuId = menuId;
      return true;
    }
  }

  // Method to check if a menu is active
  isMenuActive(menuId: string): boolean {
    return this.activeMenuId === menuId;
  }
} 